const addWeekToDate = (date, numberOfweeks) => {
  const result = new Date(date)

  result.setDate(result.getDate() + numberOfweeks * 7)

  return result
}

export default addWeekToDate
